<template>
  <div class="settings-wrapper">
    <div
      class="settings-main__overlay"
      v-show="$loader.isLoading('getParsedPackets')"
    >
      <spinner
        line-fg-color="#313942"
        line-bg-color="#eee"
        message="IoT Objekte werden geladen"
        :spacing="10"
        :size="16"
      ></spinner>
    </div>
    <div class="settings">
      <div class="settings__header">
        <div class="settings__header-title">{{ data.title }}</div>
        <div class="settings__header-close" @click="$emit('close')">
          <i class="far fa-times" />
        </div>
      </div>
      <div class="settings__content">
        <div class="col-md-4 float-right">
          <b-form-select
            v-model="selectedTime"
            :options="optTime"
            class="chart-select"
            @change="updateChart"
          ></b-form-select>
        </div>
        <div class="col-md-4 float-left">
          <b-form-select
            v-model="selectedType"
            :options="optTypes"
            class="chart-select"
            @change="parseData"
          ></b-form-select>
        </div>
        <div class="col-md-4 float-left">
          <b-form-select
            v-model="selectedGraph"
            :options="optGraph"
            class="chart-select"
          ></b-form-select>
        </div>
        <div class="charts-graph">
          <line-graph
            v-if="selectedGraph == 'Line'"
            :chartData="chartdata"
            :options="options"
          ></line-graph>
          <bar-graph
            v-if="selectedGraph == 'Bar'"
            :chartData="chartdata"
            :options="options"
          ></bar-graph>
        </div>
      </div>
      <div class="settings__footer">
        <b-table
          :items="items"
          :fields="fields"
          table-class="chart-sum-tbl"
          v-if="meter"
        ></b-table>
      </div>
    </div>
  </div>
</template>

<script>
import LineGraph from "../Graphs/LineGraph";
import BarGraph from "../Graphs/BarGraph";
import ApiService from "../../services/api-service";
import ChartService from "../../services/chart-service";
import Spinner from "vue-simple-spinner";

export default {
  name: "Charts",
  components: {
    LineGraph,
    BarGraph,
    Spinner
  },
  props: ["data", "title"],
  mounted() {
    if (this.data.keys.length) {
      this.optTypes = this.data.selectOptions;
      this.selectedType = this.data.keys[0];
      this.chartdata.datasets[0].label = this.units[this.selectedType]; //this.data.title;
      this.labels = this.data.labels;
      this.parsedPacketdata = this.data.data;
      // this.options.scales.yAxes[0].scaleLabel.labelString = this.selectedType;
      this.parseData();
    }
  },
  data() {
    return {
      selectedTime: "7d",
      optTime: [
        { value: "1d", text: "letzte 24 Stunden" },
        { value: "7d", text: "Letzte 7 Tage" },
        { value: "30d", text: "Letzte 30 Tage" }
      ],
      selectedGraph: "Bar",
      optGraph: [
        { value: "Bar", text: "Bar" },
        { value: "Line", text: "Line" }
      ],
      selectedType: "",
      optTypes: [],
      chartdata: {
        labels: [],
        datasets: [
          {
            label: "",
            backgroundColor: "#003871a8",
            data: []
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        ticks: { beginAtZero: true },
        scales: {
          xAxes: [
            {
              display: true,
              scaleLabel: {
                display: true,
                labelString: "Zeit"
              }
            }
          ],
          yAxes: [
            {
              display: true,
              gridLines: {
                display: true
              },
              scaleLabel: {
                display: true
                // labelString: "Werte"
              },
              ticks: {
                min: 0
              }
            }
          ]
        }
      },
      labels: [],
      parsedPacketdata: [],
      fields: ["Gesamtsumme", "Durchschnitt"],
      items: [],
      meter: false,
      units: {
        Temp: "Temperatur in °C",
        temp: "Temperatur in °C",
        temperature: "Temperatur in °C",
        kWh: "Strom - Tagesverbrauch in kWh",
        wH: "Strom - Tagesverbrauch in kWh",
        Humidity: "Feuchtigkeit in %",
        humidity: "Feuchtigkeit in %",
        Light: "Licht in lm",
        light: "Licht in lm",
        Motion: "Bewegungen registriert 0 = nein / 1 = ja",
        motion: "Bewegungen registriert 0 = nein / 1 = ja",
        CO2: "CO2-Werte in ppm",
        co2: "CO2-Werte in ppm",
        SoundPeak: "Schalldruckpegel in dB",
        sound_peak: "Schalldruckpegel in dB",
        sound_avg: "Schalldruckpegel in dB",
        SoundAvg: "Schalldruckpegel in dB",
        waterDetectedInt: "Trocken/Leck",
        parked: "Parkplatzbelegung",
        cumulative_m3: "Wasser - Tagesverbrauch in m3",
        cumulative_l: "Wasser - Tagesverbrauch in L"
      },
      timeLables: {
        "1d": "24 Stunden",
        "7d": "7 Tagen",
        "30d": "30 Tagen"
      },
      timeLablesOfficeLight: {
        "1d": "24 Stunden"
      }
    };
  },
  methods: {
    updateChart() {
      let body = {
        limit: 100000,
        from: this.selectedTime
      };
      let row = this.$store.state.device;
      ApiService.getParsedPackets(row.id, body)
        .then(packets => {
          let data = ChartService.parseDataForChart(
            row,
            packets,
            this.selectedTime
          );
          this.labels = data.labels;
          this.parsedPacketdata = data.data;
          this.parseData();
          this.$loader.endLoading("getParsedPackets");
        })
        .catch(response => {
          this.loading = false;
          this.$notify({
            type: "error",
            message: `Fehler beim laden des Packets: ${response}`,
            position: "bottom-left"
          });
        });
    },
    parseData() {
      let chartData = this.parsedPacketdata[this.selectedType];
      let min = null;
      let max = null;
      if (chartData) {
        min = Math.min(...chartData);
        max = Math.max(...chartData);
      }

      if (this.selectedType === "Light") {
        this.optTime = [{ value: "1d", text: "letzte 24 Stunden" }];
        this.selectedTime = "1d";
      }
      // let selectedUnit = this.optTypes.find(
      //   element => element.value == this.selectedType
      // );
      //  let sum = chartData.reduce((a, b) => a + b, 0);
      //  let avg = ChartService.arrayAverage(chartData);

      this.chartdata.labels = this.labels[this.selectedType];
      this.chartdata.datasets[0].data = this.parsedPacketdata[
        this.selectedType
      ];
      // this.options.scales.yAxes[0].scaleLabel.labelString = this.units[
      //   this.selectedType
      // ];
      this.chartdata.datasets[0].label = this.units[this.selectedType];
      switch (this.selectedType) {
        case "kWh":
        case "wH":
        case "Light":
          this.options.scales.yAxes[0].ticks.min = 0;
          this.options.scales.yAxes[0].ticks.max = max + 10;
          this.options.scales.yAxes[0].ticks.stepSize = 0;

          /*(this.fields = ["Gesamtsumme", "Durchschnitt"]), (this.items = []);
          this.items.push({ Gesamtsumme: sum, Durchschnitt: avg });*/
          break;
        case "isOpen":
        case "tor1CurrentState":
        case "parked":
        case "Motion":
          this.options.scales.yAxes[0].ticks.min = 0;
          this.options.scales.yAxes[0].ticks.max = 1;
          this.options.scales.yAxes[0].ticks.stepSize = 100;
          break;
        case "motion":
          this.options.scales.yAxes[0].ticks.min = 0;
          this.options.scales.yAxes[0].ticks.max = 1;
          this.options.scales.yAxes[0].ticks.stepSize = 10;
          break;
        default:
          this.options.scales.yAxes[0].ticks.min = min - 2;
          this.options.scales.yAxes[0].ticks.max = max + 10;
          this.options.scales.yAxes[0].ticks.stepSize = 0;
          break;
      }

      this.$bus.emit("updateLine");
      this.$bus.emit("updateBar");
    }
  }
};
</script>
